import ActionTypes from "../../constants/action-types";

export const updateSocketStatus = (payload) => ({
  type: ActionTypes.UPDATE_SCOKET_STATUS,
  payload,
});
